import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ComisionesManualesAdminComponent from "../../../components/comisionesManuales/administracion/ComisionesManualesAdmin";
import {
  ComisionesManualesAdminStore,
  comisionesManualesAdminStore
} from "./ComisionesManualesAdmin.store";
import {
  ComisionesManualesAdminDispatcher,
  comisionesManualesAdminDispatcher
} from "./ComisionesManualesAdmin.dispatcher";
import Layout from "../../../components/layout";

interface Props
  extends ComisionesManualesAdminStore,
    ComisionesManualesAdminDispatcher {}
interface State {}

@Router()
@ReduxConnect(comisionesManualesAdminStore, comisionesManualesAdminDispatcher)
export default class ComisionesManualesAdminContainer extends Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Administración de Comisiones Manuales" />
          <ComisionesManualesAdminComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
